import { requestCommitmentStatuses } from 'legacy/lut/features/partner360/commitment'
import { requestRecalculateCompleteness } from 'legacy/lut/features/partner360/completeness'
import {
  selectFinancialYear,
  selectProgramType,
} from 'legacy/lut/features/partner360/configuration'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectAppOwnerId } from 'core-components/sitebuilder/store/selectors/selectAppOwnerId'
import { copyFromPreviousYear } from 'partner360/services/keyInitiatives/copyFromPreviousYear'

interface IUseCopyFromPrevYear {
  onChangeLoading: (status: boolean) => void
  partnerId: string
  fetch: (force: boolean) => void
}

export const useCopyFromPrevYear = ({
  onChangeLoading,
  partnerId,
  fetch,
}: IUseCopyFromPrevYear) => {
  const [showCopyFromPrevYearDialog, setShowCopyFromPrevYearDialog] = useState(false)

  const dispatch = useAppDispatch()

  const programType = useSelector(selectProgramType)
  const fYear = useSelector(selectFinancialYear)
  const ownerId = useSelector(selectAppOwnerId)

  const triggerCompleteness = useCallback(async () => {
    const parameters = {
      partnerId,
      fYear,
    }

    dispatch(requestRecalculateCompleteness(parameters))
    dispatch(requestCommitmentStatuses(parameters))
  }, [partnerId, fYear, dispatch])

  const copyFromPrevYear = useCallback(async () => {
    onChangeLoading(true)
    await copyFromPreviousYear({
      ownerId,
      partnerId,
      fYear,
      programType,
    })

    await triggerCompleteness()
    await fetch(true)

    onChangeLoading(false)
  }, [onChangeLoading, fetch, triggerCompleteness, ownerId, partnerId, fYear, programType])

  const openCopyFromPrevYearDialog = useCallback(() => {
    setShowCopyFromPrevYearDialog(true)
  }, [])

  const closeCopyFromPrevYearDialog = useCallback(() => {
    setShowCopyFromPrevYearDialog(false)
  }, [])

  const handleCopyFromPrevYear = useCallback(async () => {
    await copyFromPrevYear()
  }, [copyFromPrevYear])

  return {
    showCopyFromPrevYearDialog,
    handleCopyFromPrevYear,
    openCopyFromPrevYearDialog,
    closeCopyFromPrevYearDialog,
  }
}
